import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CardFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M20.48 15.58C20.48 17.3 19.24 18.54 17.52 18.54H6.48C4.76 18.54 3.52 17.3 3.52 15.58V8.34C3.52 6.62 4.76 5.38 6.48 5.38H17.52C19.24 5.38 20.48 6.62 20.48 8.34V15.58ZM5.32 10.92H18.68V9.08H5.32V10.92ZM10.76 14.28C10.76 13.7 10.26 13.22 9.7 13.22H7.82C7.26 13.22 6.76 13.7 6.76 14.28C6.76 14.86 7.26 15.34 7.82 15.34H9.7C10.26 15.34 10.76 14.86 10.76 14.28Z" />
    </SvgIcon>
  );
});
